import '../../../styles/financial-lease-calculator.css';
import { init } from '../../financial-lease-calculator.js';

init(document);
